/* eslint-disable jsdoc/require-jsdoc */
import React, { useState } from 'react';
import { Flex } from '../../components/base/layout-components';
import Text from '../../components/base/Text';
import { STEPS_BUTTONS, STEPS_COMPONENTS, STEPS_INDEXES } from './constants';
import styled from 'styled-components';
import { PROVIDER_NAMES } from 'common/constants/constants';

const Wrapper = styled(Flex)`
  margin-top: 4.3rem;
  height: 100%;
  width: 100%;
  overflow-x: auto;
`;

const GitStreamWizardModal = ({
  integrationName,
  onDoneClick,
  width,
  sensorName,
  sensorAuth
}) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const currentStep = STEPS_INDEXES[currentStepIndex];
  const isGitlab = sensorName?.toLowerCase() === PROVIDER_NAMES.gitlab;

  // in Gitlab we skip on the reauth step
  const handleNextStep = () => {
    let newStepIndex = currentStepIndex + 1;
    if (isGitlab && currentStepIndex === 3) {
      newStepIndex = 4; // Skip to DONE step
    }
    setCurrentStepIndex(newStepIndex);
  };

  const handlePreviousStep = () => {
    setCurrentStepIndex(currentStepIndex - 1);
  };

  return (
    <Flex
      width={width}
      direction='column'
      padding='big'
      height='100%'
      borderBox
    >
      <Text
        weight='400'
        size='x-medium'
      >{`${integrationName} | Add gitStream Integration`}</Text>
      <Wrapper data-testid={`step-${currentStep.toLowerCase()}`}>
        {STEPS_COMPONENTS[currentStep](sensorName?.toLowerCase(), sensorAuth)}
      </Wrapper>
      <Flex justify='flex-end' mt='small'>
        {STEPS_BUTTONS[currentStep]({
          onNextClick: handleNextStep,
          onPreviousClick: handlePreviousStep,
          onDoneClick,
          sensorName
        })}
      </Flex>
    </Flex>
  );
};

export default GitStreamWizardModal;
